import React, {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';



const NavBar = ({ showNavBarContent,closeNavBarContent }) => {
  const [navBar,setNavBar] = useState(showNavBarContent)

  useEffect(() => {
    setNavBar(showNavBarContent)
  },[showNavBarContent])

  function handleNavBarClose(){
    setNavBar(false)
  }

  function redirectDashboard(){
    if(process.env.NODE_ENV === "development") {
      window.location.href='/dashboard'
    }   else {
      window.location.href='/offline_quiz/dashboard'
    }
  }
  function redirectProjects(){
    if(process.env.NODE_ENV === "development") {
      window.location.href='/projects'
    }   else {
      window.location.href='/offline_quiz/projects'
    }
  }
  
  const renderMUIDrawer = () => {
    return (
    <div>
      <React.Fragment>
        <Drawer
          anchor={"left"}
          open={navBar}
          // onClose={() => setShowNavBarContent(false)}
          onBackdropClick={()=>{handleNavBarClose();closeNavBarContent()}}
        >
          <Box
            sx={{width: 150}}
            role="presentation"
            // onClick={() => setShowNavBarContent(false)}
            // onKeyDown={() => setShowNavBarContent(false)}
          >
            <Divider />
            <List>
              <ListItem 
                button
                onClick={() => redirectDashboard()}
                key="Dashboard"
              >
                <ListItemText primary="Dashboard" />
              </ListItem>
              <ListItem 
                button 
                onClick={() => redirectProjects()}
                key="Projects"
              >
                <ListItemText primary="Projects" />
              </ListItem>
            </List>
          </Box>
        </Drawer>
      </React.Fragment>
    </div>
    );
  }

  return (
    <>
      {renderMUIDrawer()}
      {/* {showNavBarContent ?
        <NavBarOpenWrapper className="NavBarOpenWrapper">{renderNavBarContent()}</NavBarOpenWrapper> :
        <NavBarClosedWrapper className="NavBarClosedWrapper">{renderNavBarContent()}</NavBarClosedWrapper>
      }  */}
    </>
  );
}

export default NavBar;
